module.exports = __webpack_public_path__ + "img/unassign-square.c5129f03.svg";